import { z } from 'zod';

export const ReportsScalarFieldEnumSchema = z.enum(['reportId','cityId','defaultSet','reportType','reportName','useStartDate','useEndDate','reportLevels','source','templateName','requestsPerPage','SQLWhere','SQLTables','personId','classificationId','departmentId','CETopicId','objectType','filter','description','datePeriod','startDate','endDate','defaultTopic','sortColumn','dateColumn','canExport','outputFields']);

export default ReportsScalarFieldEnumSchema;
